module.exports = __webpack_public_path__ + "media/music/fc383956e315b7ee2bd8dd09de311701.mp3";